<!-- 
  **
    菜单位置大调整 为了快速完成需求
    此页面路径是引用旧菜单的 故组件文件路径与components路径不一致
    后期有空再调整
  **
-->
<template>
  <div class="app-container">
    <list ref="list">
    
    </list>
    <!-- <edit-dialog ref="editDialog"></edit-dialog> -->
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from '@/components/business/purchase/instorage/list'
// import editDialog from '@/components/production/clothmanagement/cloth/editDialog'

export default {
  name: "instorage",
  mixins: [curdMixins],
  components: {
    list,
    // editDialog
  },
  methods: {
    delRows(){

    },
    
  }
  
};
</script>